.brand { display: inline-flex; align-items: center; gap: 12px; }
.mark { display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 50%; background: var(--pink); border: 2px solid var(--ink); box-shadow: 3px 3px 0 var(--ink); color: var(--ink); }
.glyph { width: 22px; height: 22px; }
.word { font-family: var(--font-cond); font-size: 30px; font-weight: 900; letter-spacing: -1.2px; color: var(--ink); }
.pal { color: var(--hot); }
.brand[data-tone='dark'] .word { color: var(--paper); }
@media (max-width: 639px) {
  .brand { min-height: 44px; }
  .mark { width: 34px; height: 34px; }
  .glyph { width: 19px; height: 19px; }
  .word { font-size: 26px; }
}
